import React from "react";
import {Breadcrumbs, Typography} from "@mui/material";
import {CmLinkable} from "../../../../packages/graphql-layer/src";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CCOContainer from "../../fundamentals/CCOContainer";
import HomeIcon from '@mui/icons-material/Home';
import useWindowSize from "../../../utility/useWindowSize";

interface Props {
    target: CmLinkable
}

const BREADCRUMB_STYLE = {
    m: 1,
    py: 2,
    '.MuiBreadcrumbs-separator, .MuiBreadcrumbs-li': {
        color: 'text.primary'
    }
}

function Breadcrumb(props: Props) {
    const navigationLength = props.target.navigationPath!.length
    const {lowerThanWindowSmall} = useWindowSize()
    if (navigationLength === 1) {
        return null
    }
    const breadcrumbMaxItems = lowerThanWindowSmall ? 2 : 4;
    return <CCOContainer width={"full"} withMobilePadding border={true}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>}
                     maxItems={breadcrumbMaxItems}
                     aria-label="breadcrumb"
                     sx={BREADCRUMB_STYLE}>
            {
                props.target.navigationPath!.map((item, index) =>
                    (index < navigationLength - 1) ?
                        (index == 0) ?
                            <CCOLinkable key={item!.id}
                                         target={item!}>
                                <HomeIcon sx={{mt: 1}}/>
                            </CCOLinkable>
                            :
                            <CCOLinkable key={item!.id}
                                         target={item!} type={"breadcrumb"}
                                         name={(item as any).teaserTitle}/>
                        : <Typography key={item!.id} color={'text.primary'}
                                      variant={"subtitle2"} component={'p'}>{(item as any).teaserTitle}</Typography>)
            }
        </Breadcrumbs>
    </CCOContainer>
}

export default Breadcrumb